import { Suspense, lazy } from 'react';
import { createRoot } from 'react-dom/client';

import { Toaster } from '@/components/ui/sonner.tsx';
import { Spinner } from '@/components/ui/spinner.tsx';

import './index.css';

const Providers = lazy(() => import('@/components/providers'));

const rootElement = document.getElementById('root')!;
if (!rootElement.innerHTML) {
  const root = createRoot(rootElement);
  root.render(
    <Suspense fallback={<Spinner className="w-10 h-10 mr-auto ml-auto mt-auto mb-auto" />}>
      <Providers />
      <Toaster position="top-center" closeButton richColors />
    </Suspense>,
  );
}
